import { useMemo } from "react";

import type { LinkedEventOption } from "@/content-hub/linked-events/types";

import { EventOptionsCombobox } from "./event-options-combobox";
import {
  createSelectedOption,
  useEventOptionsLoader,
} from "./use-event-options-loader";

type EventOptionSelectorProps = {
  dataTestId?: string;
  id: string;
  label: string;
  name: string;
  onChange: (eventOption: LinkedEventOption) => void;
  selectedEventExternalId?: string | null;
  selectedEventTitle?: string | null;
};

export function EventOptionSelector({
  dataTestId,
  id,
  label,
  name,
  onChange,
  selectedEventExternalId,
  selectedEventTitle,
}: EventOptionSelectorProps) {
  const loader = useEventOptionsLoader({
    loggerDetails: "Failed to fetch event options",
  });

  const selectedOption = useMemo(() => {
    if (!selectedEventExternalId) return null;

    const matchingOption = loader.options.find(
      (option) => option.id === selectedEventExternalId
    );

    if (matchingOption) return matchingOption;

    return createSelectedOption(selectedEventExternalId, selectedEventTitle);
  }, [loader.options, selectedEventExternalId, selectedEventTitle]);

  const handleChange = (eventOption: LinkedEventOption | null) => {
    if (!eventOption) return;

    onChange(eventOption);
  };

  return (
    <EventOptionsCombobox
      id={id}
      name={name}
      label={label}
      dataTestId={dataTestId}
      loader={loader}
      selectedOption={selectedOption}
      showNoneOption={false}
      onChange={handleChange}
    />
  );
}
